/**
 * @generated SignedSource<<a771e5767a52ebe5bf1f7d34b8adfbf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GenerateRegistersForNewBlockInput = {
  block: number;
  clientMutationId?: string | null | undefined;
  startingYear: number;
  teacherIds: ReadonlyArray<string | null | undefined>;
};
export type GenerateRegistersForNewBlockMutation$variables = {
  input: GenerateRegistersForNewBlockInput;
};
export type GenerateRegistersForNewBlockMutation$data = {
  readonly generateRegistersForNewBlock: {
    readonly errors: any | null | undefined;
    readonly profileGroup: {
      readonly generateRegistersForNewBlockProgress: number | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type GenerateRegistersForNewBlockMutation = {
  response: GenerateRegistersForNewBlockMutation$data;
  variables: GenerateRegistersForNewBlockMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateRegistersForNewBlockPayload",
    "kind": "LinkedField",
    "name": "generateRegistersForNewBlock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileGroupNode",
        "kind": "LinkedField",
        "name": "profileGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generateRegistersForNewBlockProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateRegistersForNewBlockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateRegistersForNewBlockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b56c2b70182636d8f8e90284154af538",
    "id": null,
    "metadata": {},
    "name": "GenerateRegistersForNewBlockMutation",
    "operationKind": "mutation",
    "text": "mutation GenerateRegistersForNewBlockMutation(\n  $input: GenerateRegistersForNewBlockInput!\n) {\n  generateRegistersForNewBlock(input: $input) {\n    success\n    errors\n    profileGroup {\n      id\n      generateRegistersForNewBlockProgress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "18ab60210d3432e722755b14881db673";

export default node;
